import { isMobile } from "react-device-detect"
import { BeforeFooterDekstop, BeforeFooterMobile, IsMobileHeader, IsPcHeader } from "../componentes/Principales"
import { imagenesAll } from "../asset/img"
import { useEffect } from "react"

export const FAQs=()=>{
  return(
    <>
      {isMobile ? < FaqsMobile /> : <FAQsDesktop />}
    </>
  )
}

const FAQsDesktops=()=>{
    useEffect(() => {
      document.title = "WAZ - FAQS";
    }, []);
  return(
    <div className="">
    <IsPcHeader imgUrlWaz={imagenesAll.logoWazBordo} />
      <div className="d-flex justify-content-center align-items-center flex-column ">
        <div className="m_w_80 mt-5 pt-5">
          <span className="m_h1">FAQs</span>
          <p className="m-0 p-0">Saber cómo destacar eso lo marca la diferencia.</p>
          <p className="m-0 p-0">Y eso es lo que hacemos en WAZ.</p>
        </div>
      </div>
      <div className="container my-5 py-5">
        <div className="row">
          <div className="col-lg">
            <AccordionList />
          </div>
          <div className="col-lg">
            <Accordion2 items2={items2} /> 
          </div>
        </div>
      </div>
      <div className="mt-5 pt-5">
        <BeforeFooterDekstop text1="¿Te gustaría confirmar" text2="si hacemos match?" textBtn="Contanos tu proyecto" />
      </div>
    </div>
  )
}
const FAQsDesktop=()=>{
    useEffect(() => {
      document.title = "WAZ - FAQS";
    }, []);
  return(
    <div className="">
    <IsPcHeader imgUrlWaz={imagenesAll.logoWazBordo} />
    <div className="container">
      <div className="row">
        <div className="col-6">
          <h3 className="m_hs m_h1 mt-5">FAQs</h3>
          <p className="m_hs fs-5 mb-5 pb-3 mt-4">Saber cómo destacar es lo que marca la diferencia. Y eso es lo que hacemos en WAZ</p>
          <AccordionList />
        </div>
        <div className="col-6 mt-5 pt-5">
          <Accordion2 items2={items2} /> 
        </div>
      </div>
      <div className="row">
      </div>
    </div>
      <div className="mt-5 pt-5">
        <BeforeFooterDekstop text1="¿Te gustaría confirmar" text2="si hacemos match?" textBtn="Contanos tu proyecto" />
      </div>
    </div>
  )
}

const FaqsMobile=()=>{
  return(
    <div className="">
      <IsMobileHeader />
      <div className="w-100 m_dfc mt-5 pt-5">
        <div className="m_w_90">
          <h3 className="m_hl m_h2 mt-5">FAQs</h3>
          <p className="m_tl mb-5 pb-3 mt-4">Saber cómo destacar es lo que marca la diferencia. Y eso es lo que hacemos en WAZ</p>
        </div>
      </div>
      <div className="w-100 mb-2 pb-3 m_dfc">
        <div className="m_w_90">
          <AccordionMobile />
        </div>
      </div>
      <BeforeFooterMobile text1="¿Te gustaría" text2="confirmar si" text3="hacemos match?" textBtn="Contanos tu proyecto" />
    </div>
  )
}


const Accordion = ({ items }) => {
  return (
    <>
      <style>
        {`
         .accordion-button::after {
  transform: rotate(0deg); /* flecha hacia abajo por defecto */
  transition: transform 0.2s ease-in-out;
}

.accordion-button:not(.collapsed)::after {
  transform: rotate(180deg); /* flecha hacia arriba al expandir */
}

        `}
      </style>

      <div className="accordion" id="accordionPanelsStayOpenExample m_bg_f2f2f2">
        {items.map((item, index) => (
          <div className="accordion-item bg-none border-0 m_bg_f2f2f2 bg-dark my-1" key={index}>
            <h4 className="accordion-header border-0" id={`heading${index}`}>
              <button
                className="accordion-button m_bg_f2f2f2 bg-white m_text_secondary border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                {item.title}
              </button>
            </h4>
            <div
              id={`collapse${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${index}`}
            >
              <div className="accordion-body m_bs m_bg_f2f2f2">{item.content}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};


export default Accordion;

const Accordion2 = ({ items2 }) => {
  return (
    <div className="accordion" id="accordionPanelsStayOpenExample2">
      {items2.map((item, index2) => (
        <div className="accordion-item bg-none border-0 my-2" key={index2}>
          <h4 className="accordion-header border-0" id={`heading2-${index2}`}>
            <button
              className="accordion-button bg-white m_text_secondary border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse2-${index2}`}
              aria-expanded="false"
              aria-controls={`collapse2-${index2}`}
            >
              {item.title}
            </button>
          </h4>
          <div
            id={`collapse2-${index2}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading2-${index2}`}
          >
            <div className="accordion-body m_bs">{item.content}</div>
          </div>
        </div>
      ))}
    </div>
  );
};




const items = [
  { title: "¿Cómo está conformado su equipo y cuál es su estructura?", content: "Nuestro equipo está formado por expertos en branding, comunicación, diseño y SEO, trabajando de manera integrada para ofrecer soluciones creativas y efectivas a nuestros clientes. 🧑‍💼👩‍🎨" },
  { title: "¿Trabajan exclusivamente para Argentina o también tienen clientes en el exterior?", content: "Trabajamos con clientes tanto en Argentina como en el exterior, adaptando nuestras estrategias a diferentes mercados y audiencias. 🌎🌍" },
  { title: "¿El presupuesto incluye la inversión en publicidad (pauta)?", content: "No, nuestro presupuesto incluye la estrategia y ejecución de publicidad en plataformas como Google Ads y Meta Ads.  💰📊" },
  { title: "¿Cuál es el método de pago?", content: "El método de pago puede variar según las preferencias del cliente. 💳💵" },
  { title: "¿Realizan reuniones previas para comprender mejor nuestras necesidades?", content: "Sí, siempre realizamos reuniones previas detalladas para comprender a fondo las necesidades y expectativas de nuestros clientes antes de comenzar cualquier proyecto. 🤝📋" },
  { title: "¿Cuánto tiempo se tarda en ver resultados tangibles?", content: "El tiempo para ver resultados tangibles puede variar según la complejidad del proyecto y los objetivos establecidos. Estaremos trabajando diligentemente para lograr resultados efectivos lo antes posible. ⏱️📈" },
];

const items2 = [
  { title: "¿Cuánto tiempo tardan en comenzar una vez contratados?", content: "Una vez contratados, comenzamos a trabajar de inmediato para asegurarnos de cumplir con los plazos establecidos y satisfacer las necesidades del cliente de manera oportuna. 🚀🕒" },
  { title: "¿Cómo trabajan ustedes?", content: "En WAZ, trabajamos de manera colaborativa y estratégica, involucrando a nuestros clientes en cada etapa del proceso. 💼🚀" },
  { title: "¿En qué son especialistas y cuáles son sus áreas de enfoque?", content: "Somos especialistas en transformación inspiradora, fusionando creatividad y estrategia para impulsar marcas hacia el éxito. Nuestras áreas de enfoque incluyen branding, estrategia de comunicación, SEO y diseño UX/UI. 💡💻" },
  { title: "¿Crean manuales de identidad de marca?", content: "Sí, creamos manuales de identidad de marca detallados y personalizados para garantizar una coherencia visual y conceptual en todas las comunicaciones de la marca. 📘✨" },
  { title: "¿Cuáles son las redes sociales con las que trabajan? ¿Trabajan con TikTok y LinkedIn?", content: "Trabajamos con una variedad de redes sociales, incluyendo Instagram, Facebook, Twitter y LinkedIn. Sí, también ofrecemos servicios para TikTok adaptándonos a las necesidades de nuestros clientes. 📱🌐" },
  { title: "¿Con qué empresas han trabajado anteriormente? ¿Pueden proporcionar ejemplos de casos de éxito?", content: "Hemos trabajado con una amplia gama de empresas, incluyendo marcas reconocidas en diferentes industrias. Estamos orgullosos de nuestros casos de éxito, y estaremos encantados de compartir ejemplos específicos contigo durante nuestra reunión. 🏆📈" },
  { title: "¿Trabajan tanto para empresas B2C como B2B?", content: "Sí, trabajamos con empresas tanto B2C como B2B, adaptando nuestras estrategias a las necesidades y características de cada tipo de negocio. 💼🛍️" },
  { title: "¿Ofrecen servicios de desarrollo de sitios web y E-commerce?", content: "¡Por supuesto! En WAZ ofrecemos servicios completos de desarrollo web y E-commerce, asegurando una presencia sólida en línea para nuestros clientes. 🖥️💳" },
];
const itemsMobile = [
  { title: "¿Cómo está conformado su equipo y cuál es su estructura?", content: "Nuestro equipo está formado por expertos en branding, comunicación, diseño y SEO, trabajando de manera integrada para ofrecer soluciones creativas y efectivas a nuestros clientes. 🧑‍💼👩‍🎨" },
  { title: "¿Trabajan exclusivamente para Argentina o también tienen clientes en el exterior?", content: "Trabajamos con clientes tanto en Argentina como en el exterior, adaptando nuestras estrategias a diferentes mercados y audiencias. 🌎🌍" },
  { title: "¿El presupuesto incluye la inversión en publicidad (pauta)?", content: "No, nuestro presupuesto incluye la estrategia y ejecución de publicidad en plataformas como Google Ads y Meta Ads.  💰📊" },
  { title: "¿Cuál es el método de pago?", content: "El método de pago puede variar según las preferencias del cliente. 💳💵" },
  { title: "¿Realizan reuniones previas para comprender mejor nuestras necesidades?", content: "Sí, siempre realizamos reuniones previas detalladas para comprender a fondo las necesidades y expectativas de nuestros clientes antes de comenzar cualquier proyecto. 🤝📋" },
  { title: "¿Cuánto tiempo se tarda en ver resultados tangibles?", content: " El tiempo para ver resultados tangibles puede variar según la complejidad del proyecto y los objetivos establecidos. Estaremos trabajando diligentemente para lograr resultados efectivos lo antes posible. ⏱️📈" },
  { title: "¿Cómo trabajan ustedes?", content: "En WAZ, trabajamos de manera colaborativa y estratégica, involucrando a nuestros clientes en cada etapa del proceso. 💼🚀" },
  { title: "¿En qué son especialistas y cuales son sus áreas de enfoque?", content: "Somos especialistas en transformación inspiradora, fusionando creatividad y estrategia para impulsar marcas hacia el éxito. Nuestras áreas de enfoque incluyen branding, estrategia de comunicación, SEO y diseño UX/UI. 💡💻" },
  { title: "¿Cuáles son las redes sociales con las que trabajan? ¿Trabajan con TikTok y Linkedin?", content: "Trabajamos con una variedad de redes sociales, incluyendo Instagram, Facebook, Twitter y LinkedIn. Sí, también ofrecemos servicios para TikTok adaptándonos a las necesidades de nuestros clientes. 📱🌐" },
  { title: "¿Trabajan tanto para empresas B2C como B2B?", content: "Sí, trabajamos con empresas tanto B2C como B2B, adaptando nuestras estrategias a las necesidades y características de cada tipo de negocio. 💼🛍️" },
  { title: "¿Ofrecen servicios de desarrollo de sitios web y E-commerce?", content: "¡Por supuesto! En WAZ ofrecemos servicios completos de desarrollo web y E-commerce, asegurando una presencia sólida en línea para nuestros clientes. 🖥️💳" },
  { title: "¿Crean manuales de identidad de marca?", content: "Sí, creamos manuales de identidad de marca detallados y personalizados para garantizar una coherencia visual y conceptual en todas las comunicaciones de la marca. 📘✨" },
];

const AccordionList=()=> <Accordion items={items} />
const AccordionList2=()=> <Accordion2 items={items2} />
const AccordionMobile=()=> <Accordion items={itemsMobile} />